// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chat-message {\n  position: relative;\n  display: block;\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0;\n  width: auto;\n  max-width: 100%;\n  padding: 10px 25px;\n  border: solid 1px #e9eaef;\n  border-radius: 10px;\n  text-align: left;\n}\n.chat-message--other {\n  border: none;\n  background-color: #f4f5f7;\n}\n.chat-message--own {\n  background-color: #cee;\n}\n", ""]);
// Exports
module.exports = exports;
